import React from 'react';

import { OnboardingScreensModal } from 'components/onboarding-screens-modal';

export const OnboardingContent = () => {
  return <OnboardingScreensModal />;
};
